module.exports = __webpack_public_path__ + "img/incharge.39f5f667.png";